import angular from 'angular';

import LiveMonitoringComponent from './LiveMonitoringComponent';

export default angular
  .module('petroCloud.admin.liveMonitoring', [])
  .component(LiveMonitoringComponent.name, LiveMonitoringComponent)
  .name;
